// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.dashboard-container .dashboard-header {
  font-family: "Lato-Bold";
  margin-top: 30px;
  border-bottom: 1px solid #dee2e6;
}
.dashboard-container .dashboard-cards {
  margin-top: 30px;
}
.dashboard-container .dashboard-cards .card .card-header {
  font-family: "Lato-Bold";
  color: #000000;
}
.dashboard-container .dashboard-cards .card .card-body h1 {
  color: #3b746b;
}

.chart {
  width: 100%;
}

.scroll-container {
  width: 100%;
  overflow: auto;
}

.chart-wrapper {
  display: flex;
  width: 100%;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/dashboard/Charts/chart.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEE;EACE,wBAAA;EACA,gBAAA;EACA,gCAAA;AAEJ;AAAE;EACE,gBAAA;AAEJ;AAAM;EACE,wBAAA;EACA,cAAA;AAER;AACQ;EACE,cAAA;AACV;;AAUA;EAKE,WAAA;AAXF;;AAiBA;EACE,WAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,WAAA;EACA,cAAA;AAdF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n.dashboard-container {\n  .dashboard-header {\n    font-family: 'Lato-Bold';\n    margin-top: 30px;\n    border-bottom: 1px solid #dee2e6;\n  }\n  .dashboard-cards {\n    margin-top: 30px;\n    .card {\n      .card-header {\n        font-family: 'Lato-Bold';\n        color: #000000;\n      }\n      .card-body{\n        h1{\n          color:#3b746b;\n        }\n      }\n    }\n  }\n}\n\n// .chart-container {\n//   // width: 100%;\n//   // display: flex;\n// }\n.chart {\n  // display: block;\n  \n  // min-width: 400px;\n  // min-width: 400px;\n  width: 100%;\n  // height: 100%;\n  // height: fit-content;\n  // padding: 5px;\n}\n\n.scroll-container {\n  width: 100%;\n  overflow: auto;\n}\n\n.chart-wrapper {\n  display: flex;\n  width: 100%;\n  overflow: auto;\n}\n\n// .custom-legend-wrapper {\n//   display: flex;\n//   flex-direction: row;\n//   flex-wrap: wrap;\n//   gap: 10px;\n//   align-items: center;\n\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
